// extracted by mini-css-extract-plugin
export default {"searchIcon":"input_searchIcon__BEx4k","searchIconClickable":"input_searchIconClickable__8GX+N","searchCloseIcon":"input_searchCloseIcon__UT6Ha"};